function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeedraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1045.5 386.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.85,156c-1.33-1.86-1.06-3.18.53-4.77L15.15,139q2.78-2.38,4.76.8c12.45,20.65,34.16,27,57.19,27,23.56,0,45.54-6.88,45.54-31,0-21.19-14.56-28.33-50.83-32.84C32.88,97.7,7.47,83.4,7.47,49.78,7.47,20.12,33.41,0,74.72,0c23.83,0,47.92,7.68,65.93,27.8,1.32,1.85,1.32,3.71-.27,5L127.14,44.75a3,3,0,0,1-4.76-.27C109.67,29.92,93.52,23,74.19,23c-25.42,0-42.63,9-42.63,26.21,0,18,13.5,25.15,49.51,29.39,38.39,4.5,65.93,18,65.93,56.13,0,35.21-28.07,55.07-69.9,55.07C46.39,189.84,18.32,180.31.85,156Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.72,94c0,54-37.86,92.14-94.52,92.14H553.33a3.19,3.19,0,0,1-3.44-3.44V6.88a3.2,3.2,0,0,1,3.44-3.44H618.2C674.86,3.44,712.72,41.3,712.72,94Zm-26.21,0c0-40.24-26.74-67.25-69.1-67.25H574.78V162.83h42.63C659.77,162.83,686.51,135.56,686.51,94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.24,182.16,979.05,6.09a4,4,0,0,0-4-2.65H948.33a4,4,0,0,0-4,2.65L879.38,179l-51-66.42c30.19-5.3,46.87-26.74,46.87-54,0-31.77-22.51-55.07-62.22-55.07H746.34a3.2,3.2,0,0,0-3.44,3.44V182.69a3.2,3.2,0,0,0,3.44,3.44h18a3.19,3.19,0,0,0,3.44-3.44V113.85h30.45L850.93,184a5.12,5.12,0,0,0,4.23,2.12h24.36a4,4,0,0,0,.62-.06,4.91,4.91,0,0,0,.68.06h18a3.75,3.75,0,0,0,4-2.65l16.68-44.74h84.46l16.69,44.74c.52,1.86,2.11,2.65,4,2.65h18C1045,186.13,1046,184.54,1045.24,182.16ZM767.79,91.08V26.74h43.69c24.36,0,38.12,12.71,38.12,32,0,19.06-13.76,32.3-38.12,32.3ZM928,116l33.89-90.82L995.46,116Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.35,
    y: 3.44,
    width: 125.76,
    height: 23.3,
    rx: 2.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.77,
    y: 83.27,
    width: 125.76,
    height: 23.3,
    rx: 2.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.35,
    y: 162.83,
    width: 125.76,
    height: 23.3,
    rx: 2.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.47,
    y: 3.44,
    width: 125.76,
    height: 23.3,
    rx: 2.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.9,
    y: 83.27,
    width: 125.76,
    height: 23.3,
    rx: 2.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.47,
    y: 162.83,
    width: 125.76,
    height: 23.3,
    rx: 2.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 258.09,
    x2: 1042.5,
    y2: 258.09,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.51,287.94h9.54c1.26,0,1.82.84,1.4,2.1L55.23,383.3a2,2,0,0,1-2.1,1.4h-14a2,2,0,0,1-2.1-1.4L2.64,290c-.42-1.26.14-2.1,1.4-2.1h9.68a2,2,0,0,1,2.1,1.4l30.29,83,30.3-83A2,2,0,0,1,78.51,287.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.52,300.28H163.91v30.57h44.46a1.69,1.69,0,0,1,1.82,1.82V341a1.69,1.69,0,0,1-1.82,1.82H163.91v29.59h51.61a1.7,1.7,0,0,1,1.83,1.82v8.7a1.7,1.7,0,0,1-1.83,1.82h-63a1.69,1.69,0,0,1-1.82-1.82V289.76a1.69,1.69,0,0,1,1.82-1.82h63a1.7,1.7,0,0,1,1.83,1.82v8.69A1.7,1.7,0,0,1,215.52,300.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.81,287.94h9.12a1.69,1.69,0,0,1,1.82,1.82v93.12a1.69,1.69,0,0,1-1.82,1.82H350a2.4,2.4,0,0,1-2.24-1.12l-52.31-77.83v77.13a1.7,1.7,0,0,1-1.83,1.82h-9.11a1.7,1.7,0,0,1-1.83-1.82V289.76a1.7,1.7,0,0,1,1.83-1.82h13.32a2.72,2.72,0,0,1,2.24,1.12L351,364.51V289.76A1.69,1.69,0,0,1,352.81,287.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.4,289.76v8.69a1.69,1.69,0,0,1-1.82,1.83H466.83v82.6A1.69,1.69,0,0,1,465,384.7h-9.39a1.7,1.7,0,0,1-1.83-1.82v-82.6H425a1.69,1.69,0,0,1-1.82-1.83v-8.69a1.69,1.69,0,0,1,1.82-1.82h70.55A1.69,1.69,0,0,1,497.4,289.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.91,340.39V289.76a1.69,1.69,0,0,1,1.82-1.82h9.54a1.69,1.69,0,0,1,1.82,1.82v49.5c0,23.56,11.36,34.5,27.35,34.5s27.49-10.94,27.49-34.5v-49.5a1.69,1.69,0,0,1,1.82-1.82h9.4a1.69,1.69,0,0,1,1.82,1.82v50.63c0,29.59-17.67,46.28-40.53,46.28S553.91,370,553.91,340.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.33,383.58l-27.91-37.16H717.29v36.46a1.69,1.69,0,0,1-1.82,1.82h-9.54a1.69,1.69,0,0,1-1.82-1.82V289.76a1.69,1.69,0,0,1,1.82-1.82h35.34c21,0,33,12.34,33,29.17,0,14.44-8.84,25.8-24.82,28.61l28.18,36.74c.85,1.12.43,2.24-1.12,2.24h-12.9A2.72,2.72,0,0,1,761.33,383.58Zm-44-49.23h23.14c12.9,0,20.19-7,20.19-17.1,0-10.24-7.29-17-20.19-17H717.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.47,300.28H854.86v30.57h44.46a1.69,1.69,0,0,1,1.82,1.82V341a1.69,1.69,0,0,1-1.82,1.82H854.86v29.59h51.61a1.7,1.7,0,0,1,1.83,1.82v8.7a1.7,1.7,0,0,1-1.83,1.82h-63a1.69,1.69,0,0,1-1.82-1.82V289.76a1.69,1.69,0,0,1,1.82-1.82h63a1.7,1.7,0,0,1,1.83,1.82v8.69A1.7,1.7,0,0,1,906.47,300.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.09,368.71a1.68,1.68,0,0,1,.28-2.52l7.29-6.45a1.48,1.48,0,0,1,2.53.42c6.59,10.94,18.09,14.3,30.29,14.3,12.48,0,24.12-3.64,24.12-16.4,0-11.22-7.71-15-26.93-17.39-20.61-2.81-34.07-10.38-34.07-28.19,0-15.71,13.74-26.37,35.62-26.37,12.62,0,25.38,4.07,34.92,14.73a1.81,1.81,0,0,1-.14,2.66l-7,6.31a1.58,1.58,0,0,1-2.52-.14c-6.73-7.71-15.29-11.36-25.52-11.36-13.47,0-22.58,4.77-22.58,13.89,0,9.53,7.15,13.32,26.22,15.56,20.34,2.39,34.92,9.54,34.92,29.73,0,18.66-14.86,29.18-37,29.18C989.21,386.67,974.35,381.62,965.09,368.71Z",
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedraLogo);
export default __webpack_public_path__ + "static/media/seedra-logo.4a3cc6c12a502ed51045a129473e60a9.svg";
export { ForwardRef as ReactComponent };